"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NcoVariableTree = void 0;
const normalizeNcoJSON_1 = require("./normalizeNcoJSON");
class NcoVariableTree {
    constructor(rawNcoJson, targetVariableKey, config) {
        var _a, _b, _c, _d;
        this.rawNcoJson = rawNcoJson;
        this.targetVariableKey = targetVariableKey;
        this.config = config;
        this.children = (nodePointer) => {
            const nextDimensionShapeKey = this.targetVariable.shape[nodePointer.length];
            if (!nextDimensionShapeKey) {
                return false;
            }
            const nextDimensionLength = this.rawNcoJson.dimensions[nextDimensionShapeKey];
            return new Array(nextDimensionLength).fill(0).map((_, i) => [...nodePointer, i]);
        };
        this.shouldIncludeNodePointer = (nodePointer) => {
            var _a, _b;
            const dimensionKey = this.targetVariable.shape[nodePointer.length - 1];
            const filterDimensionConfig = (_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.excludeDimensions) === null || _b === void 0 ? void 0 : _b.find((filterDimension) => filterDimension.dimensionKey === dimensionKey);
            if (!filterDimensionConfig) {
                return true;
            }
            const lastSegment = nodePointer[nodePointer.length - 1];
            return filterDimensionConfig.inclusiveIndexRange[0] <= lastSegment && lastSegment <= filterDimensionConfig.inclusiveIndexRange[1];
        };
        this.getData = (nodePointer) => {
            const data = nodePointer.reduce((datums, nodePointerIndex) => datums[nodePointerIndex], this.targetVariable.data);
            if (data === null || data === undefined || this.nullableValues.includes(data.toString())) {
                return null;
            }
            else {
                return data;
            }
        };
        this.getDimensionIndex = (dimensionName, nodePointer) => {
            return nodePointer[this.targetVariable.shape.indexOf(dimensionName)];
        };
        this.getDimensionValue = (dimensionName, nodePointer) => {
            var _a;
            const nodePointerDimensionIndex = this.getDimensionIndex(dimensionName, nodePointer);
            return ((_a = this.rawNcoJson.variables[dimensionName]) === null || _a === void 0 ? void 0 : _a.data[nodePointerDimensionIndex]) || nodePointerDimensionIndex;
        };
        this.flattenData = () => {
            const maximumIterations = Object.values(this.rawNcoJson.dimensions).reduce((prev, current) => prev * current, 1) * Object.keys(this.rawNcoJson.dimensions).length + 1;
            const dimensionShapeKey = this.targetVariable.shape[0];
            const initialNodePointers = new Array(this.rawNcoJson.dimensions[dimensionShapeKey]).fill(0).map((_, i) => [i]);
            const leaves = [];
            let stack = initialNodePointers;
            for (let i = 0; i < maximumIterations; i++) {
                if (stack.length === 0) {
                    return leaves;
                }
                const lifoPointer = stack.pop();
                if (!this.shouldIncludeNodePointer(lifoPointer)) {
                    continue;
                }
                const childrenNodes = this.children(lifoPointer);
                if (childrenNodes) {
                    stack.push(...childrenNodes);
                }
                else {
                    leaves.push(lifoPointer);
                }
            }
            throw new Error('Reached maximum number of iterations');
        };
        this.normalizedNcoJson = normalizeNcoJSON_1.normalizeNcoJson(rawNcoJson);
        this.targetVariable = this.normalizedNcoJson.variables.find((val) => val.key === this.targetVariableKey);
        this.nullableValues = [(_b = (_a = this.targetVariable.attributes) === null || _a === void 0 ? void 0 : _a._FillValue) === null || _b === void 0 ? void 0 : _b.toString(), (_d = (_c = this.targetVariable.attributes) === null || _c === void 0 ? void 0 : _c.missing_value) === null || _d === void 0 ? void 0 : _d.toString()];
    }
}
exports.NcoVariableTree = NcoVariableTree;
